import React, { TextareaHTMLAttributes } from 'react';

import styled from 'styled-components';

interface STextareaProps {
  error?: string;
  height?: number;
}

const STextarea = styled.textarea<STextareaProps>`
  width: 100%;
  height: ${(props) => (props.height ? `${props.height}px` : 'initial')};
  border-radius: 4px;
  font-size: 15px;
  padding: 10px 16px;
  outline: none;
  resize: none;
  ${({
    theme: {
      global,
      ui: { input },
    },
    error,
  }) => ({
    color: global.textColor,
    backgroundColor: global.bgColor,
    border: `1px solid ${error ? global.errorColor : input.borderColor}`,
  })}

  &:focus {
    ${({ theme: { global }, error }) => ({
      border: `1px solid ${error ? global.errorColor : global.mainColor}`,
    })}
  }
`;

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
  height?: number;
}

const Textarea = React.forwardRef((props: TextareaProps, ref: React.ForwardedRef<HTMLTextAreaElement>) => {
  return <STextarea ref={ref} {...props} />;
});

export default Textarea;
